window["ThemeComponent_ProductUpsell"] = ({ product, variant, quantity }) => {
  return {
    productRoot: null,
    product,
    current_variant: variant,
    quantity,
    loading: false,
    cartAddErrorMessage: null,
    get currentVariantAvailable() {
      if (this.current_variant) {
        return this.current_variant.available;
      } else {
        return false;
      }
    },
    formatMoney(price, moneyFormat = theme.defaultMoneyFormat) {
      return formatMoney(price, moneyFormat);
    },
    init() {
      // Set a product root for nested components
      // to use instead of $root (which refers to their root)
      this.productRoot = this.$root;

      //check if window is /cart page
      this.isCartPage = window.location.pathname === "/cart";
    },
    addToCart(explicitVariantId, explicitQuantity) {
      // Use explicit parameters if provided, otherwise fall back to component data
      const variantId = explicitVariantId || this.current_variant.id;
      const variantQuantity = explicitQuantity || this.quantity;

      this.loading = true;
      this.cartAddErrorMessage = null;

      liveRegion(window.theme.strings.loading);

      let modalCart = theme.settings.cart_type === "drawer" && !this.isCartPage;

      const items = [
        {
          id: variantId,
          quantity: variantQuantity,
        },
      ];

      const requestData = { items };

      // Add sections for cart updates
      if (modalCart) {
        requestData.sections =
          "drawer-cart-items,drawer-cart-footer,cart-item-count,cart-items-count";
      } else if (this.isCartPage) {
        requestData.sections =
          "cart-items,cart-footer,cart-item-count,cart-items-count";
      } else {
        requestData.sections = "cart-item-count,cart-items-count";
      }

      requestData.sections_url = window.location.pathname;

      fetch(window.Shopify.routes.root + "cart/add.js", {
        method: "POST",
        headers: {
          "Content-Type": "application/json",
          "X-Requested-With": "XMLHttpRequest",
        },
        body: JSON.stringify(requestData),
      })
        .then((response) => response.json())
        .then((data) => {
          if (data.status) {
            this.loading = false;

            let message = data.description || data.message;
            this.cartAddErrorMessage = message;

            document.body.dispatchEvent(
              new CustomEvent("switch:productform:adderror", {
                detail: {
                  source: "product-upsell",
                  variantId: variantId,
                  errors: data.errors || data.description,
                  message,
                },
              }),
            );

            return;
          }

          this.loading = false;

          const afterAddEvent = new CustomEvent("switch:cart:afteradditem", {
            bubbles: true,
            detail: { response: data },
          });
          document.body.dispatchEvent(afterAddEvent);
        })
        .catch((error) => {
          this.loading = false;
          this.cartAddErrorMessage =
            "There was an error adding the item to your cart.";
          console.error("Error:", error);
        });
    },
  };
};
